module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_05-4791f99d74813ca7093e63b68c0a3ff5.png";